import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationControlService {
  private readonly messageService = inject(MessageService);

  /**
   * Función para lanzar una notificación simple
   * @param summary - El resumen de la notificación
   * @param detail - El detalle de la notificación
   * @param life - La duración de la notificación (en milisegundos)
   * @param severity - El nivel de severidad de la notificación
   */
  launchNotification(
    summary: string,
    detail: string,
    life = 4000,
    severity: 'success' | 'info' | 'warn' | 'error' = 'info',
  ) {
    this.messageService.add({
      key: 'default',
      severity,
      summary,
      detail,
      life,
    });
  }

  /**
   * Función para lanzar una notificación push
   * @param summary - El resumen de la notificación
   * @param detail - El detalle de la notificación
   * @param extra - Información adicional para la notificación
   * @param life - La duración de la notificación (en milisegundos)
   */
  launchPush(
    summary: string,
    detail: string,
    extra: {
      avatar?: string;
      icon?: string;
      label?: string;
      action?: () => void;
    },
    life = 5000,
  ) {
    this.messageService.add({
      key: 'push',
      severity: 'info',
      summary,
      detail,
      life,
      icon: extra.icon,
      closable: false,
      data: {
        avatar: extra.avatar,
        label: extra.label,
        action: extra.action,
      },
    });
  }
}
